import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ToastService } from 'src/app/modules/shared/services/toast/toast.service';

@Component({
  selector: 'app-modal-motivo-recusa',
  templateUrl: './modal-motivo-recusa.component.html',
  styleUrls: ['./modal-motivo-recusa.component.scss'],
})
export class ModalMotivoRecusaComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    private modalCtrl: ModalController,
  ) {
    this.form = this.fb.group({
      motivo: [null, [Validators.required, Validators.maxLength(255)]],
    });
  }

  getFormControl(controlName: string) {
    return this.form.get(controlName);
  }

  close() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return this.toastService.showError(
        'Informe o motivo da recusa para continuar',
      );
    }

    return this.modalCtrl.dismiss(this.form.value.motivo, 'confirm');
  }
}
